import { Component, OnInit, Input, forwardRef, ElementRef, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, AbstractControl, Validator, ValidationErrors, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { Subject, interval, takeUntil } from 'rxjs';
import { setTimeout$, Utility } from 'src/app/core/common';
import { CalendarShortKey, PersianDate } from 'src/app/core/persian-date';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CalendarComponent),
    multi: true,
  },
  {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => CalendarComponent),
    multi: true,
  }]
})
export class CalendarComponent extends UntypedFormControl implements OnInit, ControlValueAccessor, Validator {
  _disabled: boolean;
  constructor(element: ElementRef<HTMLElement>) {
    super();
    this.required = element?.nativeElement.hasAttribute('required');
  }
  get years() {
    if (!this._years) {
      this._years = [];
      for (let i = this.minYear; i <= this.maxYear; i++) {
        this._years.push(i);
      }
    }
    return this._years;
  }
  get days() {
    return Utility.arrayFromRange(isNaN(this.pdate.month) ? 31 : this.pdate.monthDays, 1);
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  @Input() mode = 'year-month-day';
  @Input('default-year') defaultYear = new PersianDate().year;
  @Input('default-date') defaultDate: Date | 'now';
  @Input('min-year') minYear = 1313;
  @Input('max-year') maxYear = 1414;

  selected: number = -1;
  shortcuts: CalendarShortKey[] = [];
  @Input('shortcuts') set _shortcuts(shortcuts: string) {
    this.shortcuts = shortcuts.split(',').map(_ => PersianDate.DateTimeShortkeys[_.trim()]).filter(_ => _);
    this.selected = shortcuts.length > 0 ? 0 : -1;
  }
  selectShortcut(index?: number) {
    this.selected = index;
    this.setDate();
    if (this.selected == undefined)
      this.propagateChange(undefined);
  }

  PersianDate = PersianDate;
  required: boolean;
  pdate: PersianDate;
  weeks: any[][];
  _years;

  ngOnInit() {
    interval(60 * 1000).pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      if (this.shortcuts?.[this.selected]?.date)
        this.setDate();
    });
    this.setDate();
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.pdate.onchanged = undefined;
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  stopPropagation = false;
  touched = false;
  setDate(obj?: any | boolean) {
    if (this.defaultDate === 'now') this.defaultDate = new Date();
    var shortcut = this.shortcuts?.[this.selected];
    var date = (obj ? new Date(obj) : (shortcut?.date || this.defaultDate));
    if (obj) {
      this.selected = -1;
      this.touched = true;
    }

    this.pdate = date ? new PersianDate(date) : new PersianDate('');
    if (!this.mode.includes('time')) {
      this.pdate.setTime();
      date = this.pdate.toGregorian();
    }

    if (!!shortcut || !Utility.equalDate(date, this.pdate?.toGregorian()))
      this.propagateChange(date);

    this.pdate.onchanged = () => {
      if (this.stopPropagation) return;
      this.stopPropagation = true;
      try {
        if (!this.touched) {
          this.touched = true;
          if (!this.mode.includes('day') || this.mode.includes('day?')) { this.pdate.day = 1; }
          if (!this.mode.includes('month') || this.mode.includes('month?')) { this.pdate.month = 1; }
        }

        this.propagateChange(this.pdate.isNaN() ? undefined : this.pdate.toGregorian());
      } finally { this.stopPropagation = false; }
    };
  }

  validate(control: AbstractControl): ValidationErrors {

    if (this.required && this.pdate.isNaN())
      return { required: true };

    if (this.isPartial)
      return { required: true };

    return null;
  }
  get isPartial() {
    let values = [];
    if (this.mode.includes('day') && this.mode.includes('day?')) values.push(this.pdate.day);
    if (this.mode.includes('month') && this.mode.includes('month?')) values.push(this.pdate.month);
    if (this.mode.includes('year') && this.mode.includes('year?')) values.push(this.pdate.year);
    return (values.findIndex(_ => isNaN(_)) > -1 && values.findIndex(_ => !isNaN(_)) > -1);
  }
  // registerOnValidatorChange?(fn: () => void): void { }

  writeValue(obj: any): void { this.setDate(obj); }
  registerOnChange(fn: any): void { this.propagateChange = fn; }
  registerOnTouched(fn: any): void { }
  // @Input() date: Date | number | string;
  // @Output() dateChange = new EventEmitter<Date | number | string>();
  @Output() change = new EventEmitter<Date | number | string>();
  private propagateChange = (_: Date) => {
    this.setValue(_);
    this.change.emit(_);
    delete this.touched;
  };

  onmousedown(event: any) {
    if (!this.pdate.year && this.defaultYear) {
      var _ = event.target.value;
      event.target.value = this.defaultYear;
      setTimeout$(() => event.target.value = _, 100);
    }
  }
}
